module.exports = __webpack_public_path__ + "assets/img/E-32b9f391.jpg";